module.exports = __webpack_public_path__ + "img/1544112156.66849c28.jpg";